export default function getUrlPathByString(urlStr) {
    try {
        if (typeof URL !== 'undefined') {
            const urlInfo = new URL(urlStr);
            return `${urlInfo.protocol}//${urlInfo.hostname}${urlInfo.pathname}`;
        }
    }
    catch (ex) {
        return null;
    }
}
